module.exports = __webpack_public_path__ + "img/Superpagespr.com.593dff99.svg";